export default "__VITE_ASSET__BZWTZEuF__"